export const EVENT_TYPES = {
  CAPTURE_CREATED: 'capture.created',
  COLLECTION_CREATED: 'collection.created',
  COLLECTION_DUE_SOON: 'collection.due_soon',
  ORDER_DUE_SOON: 'order.due_soon',
}

export const MESSAGE_TYPES = {
  MONTHLY_INVOICE_DUE_SOON: {
    id: 'MONTHLY_INVOICE_DUE_SOON',
    label: 'Monthly invoice is due soon',
  },
  NEW_INVOICE: {
    id: 'NEW_INVOICE',
    label: 'New invoice',
  },
  ORDER_DUE_SOON: {
    id: 'ORDER_DUE_SOON',
    label: 'Invoices due soon',
  },
}
